export const initHero = () => {
  const playPauseButton = document.querySelector(".play-pause-button") as HTMLButtonElement;
  const video = document.querySelector(".picture-section__video") as HTMLVideoElement;

  if (playPauseButton) {
    playPauseButton.addEventListener("click", () => {
      playPauseButton.classList.toggle("active");

      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });
  }
}